import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloPrincipianti } from '@/mocks/articles';

export default function PrincipiantiPage() {
  return <ArticleLayout article={articoloPrincipianti} />;
}